import { BpmRolesForm } from "@/modules/bpm/features/save-bpm-role";
import Button from "@/shared/form/button";
import { FormInModal } from "@/shared/form/form-in-modal";
import { useTranslations } from "use-intl";

export function BpmRolesAdd() {
  const t = useTranslations("BpmRolesAdd");

  return (
    <FormInModal
      title={t("Add bpm roles")}
      form={(close) => <BpmRolesForm afterSubmit={close} />}
      trigger={(open) => (
        <Button accent type="primary" onClick={open}>
          {t("Add bpm roles")}
        </Button>
      )}
    />
  );
}
